module.exports = __webpack_public_path__ + "img/photo-20.731eaad6.jpg";